<template>
	<div
		:class="uploadDataObj.pageType == 'memberArchiveNewMaterials' || uploadDataObj.pageType == 'materialsEdit' ? 'imgWH250 marginBottom16 ' : '' + (uploadDataObj.pageType == 'addEquipmentPage' ? 'imgWH250' : '')">
		<!-- 服务站详情--附件上传 修改展示形式 -->
		<!-- <el-upload v-if="uploadDataObj.pageType == 'serviceStationDetails'"
			v-model:file-list="uploadDataObj.formData.fileList" :http-request="httpRequestHandle"
			:headers="uploadDataObj.uploadData" :before-upload="beforeUpload" :disabled="importData ? true : disabled"
			class="logoUploader" :style="uploadDataObj.pageType == 'addEquipmentPageReplace' ? 'height: 20px' : ''">
			<el-button type="primary" :disabled="!isGetPermission()"
				:class="uploadDataObj.formData.fileList.length > 0 ? 'marginBottom8' : ''">
				添加附件
			</el-button>
		</el-upload> -->

		<!-- 所有公共方法 v-else -->
		<el-upload ref="uploadRef" @click="handleClick" :http-request="httpRequestHandle" :show-file-list="false"
			:disabled="importData ? true : disabled" :before-upload="beforeUpload" :headers="uploadDataObj.uploadData"
			:class="getClass(uploadDataObj.pageType)"
			:style="uploadDataObj.pageType == 'serviceStationDetails' ? 'height: 20px' : ''">

			<el-button v-if="uploadDataObj.pageType == 'cardPicPreviewModal'" type="primary">上传</el-button>

			<div v-if="uploadDataObj.pageType == 'companyInformationModal' || uploadDataObj.pageType == 'enterpriseJoinPage' || uploadDataObj.pageType == 'enterpriseDataEdit'"
				class="displayFCenter positionR">
				<img v-if="uploadDataObj.formData" :src="uploadDataObj.formData"
					class="displayB objectFitC borderRadius4" />
				<el-icon v-else>
					<Plus />
				</el-icon>

				<div v-if="uploadDataObj.formData && uploadDataObj.pageType == 'enterpriseDataEdit'"
					class="resetUpload positionA left0 widthPercentage textAlignC lineHeight32 fontSize14 cursorColor marginTop4">
					重新上传
				</div>
			</div>

			<div v-if="uploadDataObj.pageType == 'noticeSetting'" class="displayFCenter">
				<img v-if="uploadDataObj.formData.avatar" :src="uploadDataObj.formData.avatar"
					class="displayB objectFitC borderRadius4" />
				<el-icon v-else>
					<Plus />
				</el-icon>
			</div>

			<el-icon
				v-if="uploadDataObj.pageType == 'memberArchiveNewMaterials' || uploadDataObj.pageType == 'materialsEdit' || uploadDataObj.pageType == 'addEquipmentPage'">
				<Plus class="imgWH40" />
			</el-icon>

			<div v-if="uploadDataObj.pageType == 'addEquipmentPageReplace'">
				<div class="displayF4Center">
					<img :src="initThemeImg(theme, 'icon_replace_h@2x')" alt="" class="imgWH16">
					<div class="color_FFF">替换</div>
				</div>
			</div>

			<el-icon v-if="uploadDataObj.pageType == 'generalArchiveCreateFile'">
				<img v-if="uploadDataObj.formData.logoImg" :src="uploadDataObj.formData.logoImg" alt=""
					class="imgWH72 borderRadius4">
				<Plus v-else class="imgWH24" />
			</el-icon>

			<div v-if="uploadDataObj.pageType == 'projectCreateAndIntroduceAndEdit'"
				class="imgWH88 borderRadius4 overflowH displayFCenter">
				<img v-if="uploadDataObj.formData" :src="uploadDataObj.formData" alt="" class="imgWH88 objectFitC">
				<el-icon v-else>
					<Plus class="imgWH16" />
				</el-icon>
			</div>

			<!-- 20260304优化 注释 -->
			<!-- <div
				v-if="uploadDataObj.pageType == 'moduleAndRequirementCreateAndEditAndDetails' || uploadDataObj.pageType == 'serviceStationDetails'">
				<div v-if="uploadDataObj.nodata" class="color_FFF">暂无附件(点击区域添加附件)</div>
				<div v-else class="displayFI4Center cursor">
					<img :src="initThemeImg(theme, uploadDataObj.pageType == 'serviceStationDetails' ? 'icon_add_files_server@2x' : 'icon_file_add@2x')"
						alt="" class="imgWH16 marginTop1">
					<div class="cursorColor fontWeight400">
						添加{{uploadDataObj.pageType == 'serviceStationDetails' ? '附件' : '（建议多文件打包上传）'}}
					</div>
				</div>
			</div> -->

			<!-- 20260304优化 新增 -->
			<div v-if="uploadDataObj.pageType == 'moduleAndRequirementCreateAndEditAndDetails' || uploadDataObj.pageType == 'serviceStationDetails'"
				:class="importData ? true : isDisbled ? 'cursorNotAllowed' : 'cursor'">
				<div class="displayFI4Center">
					<img :src="initThemeImg(theme, uploadDataObj.pageType == 'serviceStationDetails' ? 'icon_add_files_server@2x' : 'icon_file_add@2x')"
						alt="" class="imgWH16 marginTop1">
					<div class="cursorColor fontWeight400">
						添加{{uploadDataObj.pageType == 'serviceStationDetails' ? '附件' : '（建议多文件打包上传）'}}
					</div>
				</div>
			</div>

			<div v-if="uploadDataObj.pageType == 'accountMessPage'"
				class="avatarBlo borderRadius36 positionR cursor marginTop16">
				<img :src="initThemeImg(theme, 'icon-zxj@2x')" alt=""
					class="avatarTop positionA imgWH24 bottom0 right0">
				<img v-if="uploadDataObj.formData" :src="uploadDataObj.formData" alt=""
					class="avatarSty borderRadius36 objectFitC">
				<div v-else class="avatarSty"></div>
			</div>

			<div v-if="uploadDataObj.pageType == 'productDescriptionGeneratorAddAndEdit'"
				class="generatorBloSty borderRadius4 overflowH displayFCenter">
				<img v-if="uploadDataObj.formData" :src="uploadDataObj.formData" alt=""
					class="generatorBloSty displayB objectFitContain">
				<el-icon v-else class="imgWH32">
					<Plus class="fontSize32" />
				</el-icon>
			</div>

			<div v-if="uploadDataObj.pageType == 'updateNotesGeneratorAddAndEditDocument'"
				class="updateBloSty borderRadius4 overflowH displayFCenter selectBack">
				<img v-if="uploadDataObj.formData" :src="uploadDataObj.formData" alt=""
					class="updateBloSty displayB objectFitC">
				<el-icon v-else class="imgWH32">
					<Plus class="fontSize32" />
				</el-icon>
			</div>
		</el-upload>
	</div>
</template>

<script setup>
	import COS from 'cos-js-sdk-v5';
	import defaultSettings from '@/settings'
	import useUserStore from '@/store/modules/user.js'
	import {
		initThemeImg,
		setMessageQueue,
		isGetPermission
	} from '@/utils/common.js'
	import {
		sysimportUpdatePrepose,
		sysimportUploadPrepose
	} from '@/api/user'
	import {
		Plus
	} from '@element-plus/icons-vue'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		disabled: {
			type: Boolean,
			default: false
		},
		isStop: {
			type: Boolean,
			default: false
		},
		dataObj: {
			type: Object,
			default: () => {}
		} // uploadData/paramsData/pageType(传参页面)/uploadType(电子名片/工作证时参数)/formData(参数)
	})

	defineExpose({
		uploadHandle
	})

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})

	const uploadDataObj = computed(() => {
		return props.dataObj || {
			uploadData: {},
			paramsData: {},
			pageType: '',
			uploadType: null,
			formData: {}
		}
	})
	// 上传完成后 接口返回带id数据合集
	const fileList = computed(() => {
		// 初始化及提交后重置赋值
		return props.dataObj.formData.fileListId || []
	})

	const importData = ref(null) // 前置保存文件返回的信息
	const setIntervalTime = ref(null) // 轮询 直到前置接口返回需要的id
	const isStop = ref(false) // 关闭页面后 强行中断
	const uploadRef = ref(null)
	const isStopP = ref(false)

	watch(() => props.isStop, val => {
		isStopP.value = val
		console.log(isStopP.value, 'isStopP.value watch')
	}, {
		immediate: true
	})

	// 手动调用上传
	function uploadHandle() {
		if (uploadRef.value) {
			// 触发上传组件的点击事件
			uploadRef.value.$el.querySelector('.el-upload input[type="file"]')?.click()
		}
	}

	// 优化系统取消按钮 自动关闭上级弹窗问题
	function handleClick() {
		proxy.$nextTick(() => {
			const fileInput = proxy.$refs.uploadRef?.$el?.querySelector('input[type="file"]')
			if (fileInput) {
				fileInput.oncancel = (event) => {
					// console.log(event, '用户点击了系统取消按钮')
					// 执行取消后的清理逻辑
					event?.stopPropagation();
					event?.preventDefault();
				}
			}
		})
	}

	function handleCancel() {
		// 需要优化 点击上传文件取消时 弹窗跟着关闭的情况
		// proxy.$emit('update:visible', false) // 假设你有一个控制显示状态的prop或事件传递方式来关闭弹窗
	}

	// 根据不同的页面获取class
	function getClass(type) {
		let str = ''
		if (type === 'memberArchiveNewMaterials' || type === 'materialsEdit' || type === 'addEquipmentPage') {
			str = 'logoUploaderBig imgWH250 '
		} else if (type === 'moduleAndRequirementCreateAndEditAndDetails' || type === 'serviceStationDetails') {
			str = 'logoUploaderFile'
		} else if (type === 'projectCreateAndIntroduceAndEdit') {
			str = 'logoUploader overflowH height90'
		} else if (type === 'productDescriptionGeneratorAddAndEdit') {
			str = 'logoUploader overflowH generatorBloSty'
		} else if (type === 'updateNotesGeneratorAddAndEditDocument') {
			str = 'logoUploader overflowH updateBloSty'
		} else {
			str = 'logoUploader'
		}

		if (type === 'memberArchiveNewMaterials' || type === 'materialsEdit') {
			str = str + ' marginBottom16'
		} else if (type === 'generalArchiveCreateFile') {
			str = str + ' imgWH72 flexShrink0 marginTop8'
		} else if (type === 'companyInformationModal' || type === 'enterpriseJoinPage' || type === 'enterpriseDataEdit') {
			if (props.dataObj.str !== 'logoUrl') {
				str = str + ' logoUploaderSec'
			}
		}
		return str
	}

	// 公共文件/服务站详情--附件 上传
	function httpRequestHandle(e) {
		clearInterval(setIntervalTime.value)
		setIntervalTime.value = null

		setIntervalTime.value = setInterval(() => {
			if (importData.value) {
				clearInterval(setIntervalTime.value)
				setIntervalTime.value = null
				// 公共上传接口
				fileUploadFileApi(importData.value, e.file)
			}
		}, 10)
	}

	// 公共上传接口
	function fileUploadFileApi(data, file) {
		// SECRETID 和 SECRETKEY 后端返回
		const cos = new COS({
			SecretId: data.secretId, // sts服务下发的临时 secretId
			SecretKey: data.secretKey, // sts服务下发的临时 secretKey
			SecurityToken: data.sessionToken, // sts服务下发的临时 SessionToken
			StartTime: data.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
			ExpiredTime: data.expiredTime, // 临时密钥过期时间
		});
		console.log(cos, data, file, 'data, file')

		let taskIdReady = null

		cos.uploadFile({
			Bucket: 'fivethree-1317930963',
			/* 填写自己的 bucket，必须字段 */
			Region: 'ap-shanghai',
			/* 存储桶所在地域，必须字段 */
			Key: data.key,
			/* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
			Body: file, // 上传文件对象
			SliceSize: 1024 * 1024 * 20,
			/* 触发分块上传的阈值，超过20MB使用分块上传，小于20MB使用简单上传。可自行设置，非必须 */
			onTaskReady: (taskId) => {
				taskIdReady = taskId
				// taskId 可通过队列操作来取消上传 cos.cancelTask(taskId)、停止上传 cos.pauseTask(taskId)、重新开始上传 cos.restartTask(taskId)
				console.log(taskIdReady, 'taskIdReady onTaskReady');
			},
			onProgress: function(progressData) {
				console.log(progressData, isStop.value, data, progressData.percent * 100 || 1,
					'progressData isStop data percent')
				if (progressData.percent === 1) {
					// 父级手动中断上传
					if (isStopP.value) {
						// 取消/停止上传
						if (taskIdReady) {
							cos.cancelTask(taskIdReady)
							cos.pauseTask(taskIdReady)
							return
						}
					}

					console.log(isStopP.value, 'isStopP.value 新增返回实时进度')
					if (progressData.speed > 0) {
						if (!isStop.value) {
							// 调用存进度接口 非强制中断时调用
							sysimportUpdatePreposeApi(data, progressData)
							proxy.$emit('progressPercent', false)
						} else {
							setTimeout(() => {
								isStop.value = false
								console.log(isStop.value, 'isStop')
							}, 1500)
						}
					}
				} else {
					console.log(isStopP.value, taskIdReady, 'isStopP.value taskIdReady')
					// 父级手动中断上传 
					if (isStopP.value) {
						// 取消/停止上传
						if (taskIdReady) {
							cos.cancelTask(taskIdReady)
							cos.pauseTask(taskIdReady)
							return
						}
					} else {
						if (!isStop.value) {
							// 调用存进度接口 非强制中断时调用
							sysimportUpdatePreposeApi(data, progressData)
							proxy.$emit('progressPercent', true)
						} else {
							// 取消/停止上传
							if (taskIdReady) {
								cos.cancelTask(taskIdReady)
								cos.pauseTask(taskIdReady)
								return
							}
						}
					}
				}
				
				console.log(progressData.percent * 100, '传入父级百分比')
				// 20260210 新增返回实时进度
				proxy.$emit('realTimeProgressPercentHandle', progressData.percent * 100 || 1, data.fileName)
			}
		}).then(data => {
			console.log('上传成功', data);
		}).catch(err => {
			setMessageQueue('error', err)
			console.log('上传出错', err);
		});
	}

	// 调用存进度接口
	function sysimportUpdatePreposeApi(uploadData, progress) {
		// 当进度为1时 返回文件数据
		console.log(uploadData, progress, 'onProgress');
		sysimportUpdatePrepose({
			importId: uploadData.importId,
			fileId: uploadData.fileId,
			progress: progress.percent
		}).then(res => {
			if (res) {
				if (res && res.data && progress.percent === 1) {
					let data = JSON.parse(JSON.stringify(res.data))
					let pageType = uploadDataObj.value.pageType

					data.importId = importData.value ? importData.value.importId : ''

					// 服务站详情
					if (pageType === 'serviceStationDetails') {
						data.name = data.originalName
						// 向父级 传接口返回是带id附件数组合集
						fileList.value.push(data)
					}

					setTimeout(() => {
						importData.value = null
					})

					console.log(pageType === 'serviceStationDetails' ? fileList.value : data, 'datadatadatadata',
						'真正的上传成功')
					// 向父级 传接口返回的数据
					proxy.$emit('handleSuccess', pageType === 'serviceStationDetails' ? fileList.value : data)
				}
			}
		}).catch(e => {
			importData.value = null
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 通用上传前置保存
	function sysimportUploadPreposeApi(capacity, fileName, isBig) {
		let obj = uploadDataObj.value
		let uploadObj = obj.uploadData
		// moduleName/functionName/fileName/capacity/skipParameter(跳转路由参数)
		let params = {
			...uploadDataObj.value.paramsData
		}
		params.fileName = fileName
		params.capacity = capacity
		params.type = uploadObj.type
		// 添加设备remark字段
		if (obj.pageType.indexOf('addEquipmentPage') > -1) {
			params.remark = uploadObj.remark
		}

		console.log(params, 'params')
		sysimportUploadPrepose(params).then(res => {
			if (res) {
				const data = res.data
				importData.value = data
				fileList.value = []

				// 传参 是否大于20M  true 大于
				proxy.$emit('isBigFileHandle', isBig)

				console.log(data.fileName, 'data.fileName')
				// 20260210 新增返回实时进度 只要调用前置就传1
				proxy.$emit('realTimeProgressPercentHandle', 1, data.fileName)
				console.log(importData.value, 'importData.value')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 上传文件校验
	function beforeUpload(rawFile) {
		let obj = uploadDataObj.value
		let type = rawFile.type
		let size = rawFile.size
		console.log(rawFile, obj, 'rawFile')

		// 电子名片/工作证
		if (obj.pageType === 'cardPicPreviewModal') {
			console.log(type, 'rawFile.type')
			if (obj.uploadType === 1 && !['image/png'].includes(type)) {
				setMessageQueue('warning', '请上传.png格式!')
				return false
			} else if (obj.uploadType === 2 && !['application/pdf'].includes(type)) {
				setMessageQueue('warning', '请上传.pdf格式!')
				return false
			}
		} else if (obj.pageType === 'serviceStationDetails') {
			// 服务站详情--附件上传
			const isRules = ['image/png', 'image/jpg', 'image/jpeg', 'application/msword', 'application/vnd.ms-excel',
				'application/x-zip-compressed', 'video/mp4', 'audio/mp3'
			].includes(type)

			if (!isRules) {
				setMessageQueue('warning', '上传文件必须是png.jpg.jpeg.doc.xls.zip.mp4.mp3!')
				return false
			} else if (size / 1024 / 1024 / 1024 > 1) {
				setMessageQueue('warning', '上传必须不超过1G')
				return false
			}
		} else if (obj.pageType == 'memberArchiveNewMaterials' || obj.pageType == 'materialsEdit' || obj.pageType ==
			'moduleAndRequirementCreateAndEditAndDetails') {
			console.log('memberArchiveNewMaterials/materialsEdit')
		} else {
			const isImage = ['image/bmp', 'image/gif', 'image/jpeg', 'image/png', 'image/jpg'].includes(type)
			// console.log(isImage, 'isImage')
			if (!isImage) {
				// 20260203 提示语统一修改 格式异常，需图片格式上传! => 仅支持上传图片格式
				setMessageQueue('warning', '仅支持上传图片格式!')
				return false
			} else {
				// 默认图片大小限制10M 说明生成器部分-产品背景图 限制30M
				if (obj.pageType == 'productDescriptionGeneratorAddAndEdit') {
					if (size / 1024 / 1024 > 30) {
						setMessageQueue('warning', '上传必须不超过30M')
						return false
					}
				} else {
					if (size / 1024 / 1024 > 10) {
						setMessageQueue('warning', '上传必须不超过10M')
						return false
					}
				}
			}
		}

		let str = ''
		let strArr = ['#', '%', '+', '&']
		for (let i = 0; i < strArr.length; i++) {
			if (rawFile.name.indexOf(strArr[i]) > -1) {
				str = strArr[i]
				setMessageQueue('warning', '文件名不能带特殊符号' + str + '，请修改后上传')
				return
			}
		}

		// 20260116 新增注释项目追踪--创建模块/需求附件部分
		let isBig = true // 默认小于20M文件 true 
		if (size / 1024 / 1024 > 20) {
			// 20260116 新增注释 将提示移到了模块/需求详情页统一处理
			setMessageQueue('success', '上传中，请稍等')
			// 20260210 新增返回实时进度 只要调用前置就传1（大文件时）
			proxy.$emit('realTimeProgressPercentHandle', 1, rawFile.name)
		} else {
			isBig = false
			// 20260116 新增注释 将提示移到了模块/需求详情页统一处理
			// setMessageQueue('success', '已加入上传队列')
		}

		// 通用上传前置保存
		sysimportUploadPreposeApi(size, rawFile.name, isBig)
		return true
	}

	onUnmounted(() => {
		clearInterval(setIntervalTime.value)
		setIntervalTime.value = null

		isStop.value = true

		// useUserStore().isModal = false
		console.log('onUnmountedonUnmountedonUnmounted')
	})

	onMounted(() => {
		// 当前是弹窗
		// useUserStore().isModal = true
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.avatarBlo {
		width: 72px;
		height: 72px;
		background: rgba(0, 0, 0, 0.2);

		.avatarSty {
			width: 72px;
			height: 72px;
		}
	}

	.maxWidth250 {
		aspect-ratio: 1;
		max-width: 250px;
		max-height: 250px;
	}

	.height90 {
		height: 90px;
	}

	.resetUpload {
		bottom: -36px;
	}

	.generatorBloSty {
		width: 220px;
		height: 124px;

		.el-icon {
			@include color('color_555');
		}
	}

	.updateBloSty {
		width: 124px;
		height: 124px;

		.el-icon {
			@include color('color_555');
		}
	}
</style>